import React from 'react';
import {
  Grid, Theme,
} from '@material-ui/core';
import { makeStyles, createStyles } from '@material-ui/styles';

import yup from '../../utility/yup';
import { SocialMedia } from '../../components';
import {
  FacebookFIcon,
  InstagramIcon,
  LinkedinInIcon,
} from '../../components/icon/brands';

export const socialMediaSchema = {
  'options.social_linkedin_url': yup.string().url(),
  'options.social_facebook_url': yup.string().url(),
  'options.social_instagram_url': yup.string().url(),
};

const useStyle = makeStyles(({ colors, palette }: Theme) => createStyles({
  root: {
    border: `1px solid ${colors.outlines}`,
  },
  head: {
    display: 'flex',
    backgroundColor: 'rgba(89, 121, 130, 0.05);',
    borderBottom: `1px solid ${colors.outlines}`,
  },
  title: {
    fontSize: '14px',
    fontFamily: 'Roboto, sans',
    color: palette.text.primary,
    margin: '15px',
    letterSpacing: '0.5px',
  },
  logoIn: {
    color: palette.common.white,
    backgroundColor: '#1A237E',
  },
  logoFb: {
    color: palette.common.white,
    backgroundColor: '#99C7CC',
  },
  logoInst: {
    color: palette.common.white,
    backgroundColor: '#D4E157',
  },
}));


const TabSocialMedia = () => {
  const classes = useStyle();

  return (
    <Grid container className={classes.root}>
      <Grid className={classes.head} item xs={12}>
        <Grid item xs={4}>
          <h3 className={classes.title}>Platform</h3>
        </Grid>
        <Grid item xs={8}>
          <h4 className={classes.title}>URL</h4>
        </Grid>
      </Grid>
      <Grid item xs={12}>
        <SocialMedia
          label="LinkedIn"
          name="options.social_linkedin_url"
          logo={<LinkedinInIcon />}
          classes={{
            logo: classes.logoIn,
          }}
          spellCheck={false}
        />
        <SocialMedia
          label="Facebook"
          name="options.social_facebook_url"
          logo={<FacebookFIcon />}
          classes={{
            logo: classes.logoFb,
          }}
          spellCheck={false}
        />
        <SocialMedia
          label="Instagram"
          name="options.social_instagram_url"
          logo={<InstagramIcon />}
          classes={{
            logo: classes.logoInst,
          }}
          spellCheck={false}
        />
      </Grid>
    </Grid>
  );
};

export default TabSocialMedia;
